import { DataTypeProvider } from "@devexpress/dx-react-grid"
import React from "react"
//import { Link } from "react-router-dom"
import TimeAgo from 'react-timeago'
import { Box, Chip } from "@mui/material"
//import { Link } from "react-router-dom"
import { styled } from '@mui/material/styles';
//import Button from '@mui/material/Button';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

import AuthService from "../services/auth-service"

// ************************************************************

const DateFormatter = ({ value }) => {
  if (value === "0000-00-00 00:00:00")
    return <></>
  return (
    <b style={{ color: 'darkblue' }}>    
      <TimeAgo date={value} />
    </b>
  )
}
export const DateTypeProvider = props => <DataTypeProvider formatterComponent={DateFormatter} {...props} />

const RowNumFormatter = ({ row }) => {
  return <Chip label={row.row_num} size="small" variant="outlined" />  
}
export const RowNumTypeProvider = props => <DataTypeProvider formatterComponent={RowNumFormatter} {...props} />

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 500,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}));

const ItemFormatter = ({ row }) => {
  var t = row.item.split("\\").map((p, index) => {
    return (
      <React.Fragment key={index}>
        {p + " "}
        <br />
      </React.Fragment>
    )
  })
  return (      
    <HtmlTooltip
      title={
        <React.Fragment>
          {/* <Typography color="inherit">UNLOCKER</Typography> */}
          {/* <em>{"And here's"}</em> <b>{'some'}</b> <u>{'amazing content'}</u>.{' '} */}
          {/* {"It's very engaging. Right?"} */}
          {/* {row.file_hash} */}
          <Box sx={{ 
            fontFamily: 'Monospace', 
            fontSize: 12.5, 
            m: 0, 
            p: 0,
          }}>
            {t}
          </Box>
        </React.Fragment>
      }
    >
      <Box sx={{ fontFamily: 'Monospace', fontSize: 11, m: 0, p: 0 }}>
        <a href={AuthService.ApiUrl() + "SoftwareFw/download/" + row.hash} rel="noreferrer" target="_blank">{row.item}</a>
      </Box>
    </HtmlTooltip>
  )
}
export const ItemTypeProvider = props => <DataTypeProvider formatterComponent={ItemFormatter} {...props} />

const IsBetaFormatter = ({ value }) => {
  if (value) return <Chip label="1" color="warning" />
  return <Chip label="0" variant="outlined" />  
}
export const IsBetaTypeProvider = props => <DataTypeProvider formatterComponent={IsBetaFormatter} {...props} />

const CounterFormatter = ({ value }) => {
  if (value) return (
    <>
      <b style={{ color: 'green' }}>    
        {value}
      </b>
    </>
  )
  return <>{value}</>
}
export const CounterTypeProvider = props => <DataTypeProvider formatterComponent={CounterFormatter} {...props} />

// ************************************************************
// ************************************************************
// ************************************************************

export default class SoftwareFwListTableProps {
  getTableColumns() {
    return [
      { name: 'row_num',            title: '#',             getCellValue: row => row.row_num },
      { name: 'id',                 title: 'Id',            getCellValue: row => row.id },
      { name: 'created_at',         title: 'Created at',    getCellValue: row => row.created_at },
      { name: 'root',               title: 'Root',          getCellValue: row => row.root },
      { name: 'group',              title: 'Group',         getCellValue: row => row.group },
      { name: 'selector',           title: 'Selector',      getCellValue: row => row.selector },
      { name: 'version',            title: 'Version',       getCellValue: row => row.version },
      { name: 'extension',          title: 'Extension',     getCellValue: row => row.extension },
      { name: 'is_beta',            title: 'Beta',          getCellValue: row => row.is_beta },
      { name: 'file_name',          title: 'File Name',     getCellValue: row => row.file_name },
      { name: 'item',               title: 'Item',          getCellValue: row => row.item },
      { name: 'counter',            title: 'Counter',       getCellValue: row => row.counter },
      { name: 'last_download',      title: 'Last download', getCellValue: row => row.last_download },
    ]
  }
  getTableColumnWidths() {
    return [
      { columnName: 'row_num',        width: 100 },
      { columnName: 'id',             width: 0 },
      { columnName: 'created_at',     width: 120 },
      { columnName: 'root',           width: 0 },
      { columnName: 'group',          width: 100 },
      { columnName: 'selector',       width: 140 },
      { columnName: 'version',        width: 140 },
      { columnName: 'extension',      width: 80 },
      { columnName: 'is_beta',        width: 80 },
      { columnName: 'file_name',      width: 220 },
      { columnName: 'item',           width: 400 },
      { columnName: 'counter',        width: 100 },
      { columnName: 'last_download',  width: 150 },
    ]
  }
  getTableColumnExtensions() {
    return [
      { columnName: 'row_num',            align: 'right' },
      { columnName: 'id',                 align: 'right' },
      { columnName: 'created_at',         align: 'right' },
      { columnName: 'version',            align: 'right' },
      { columnName: 'is_beta',            align: 'right' },
      { columnName: 'counter',            align: 'right' },
      { columnName: 'last_download',      align: 'right' },
    ]
  }
  getTableSortingStateColumnExtensions() {
    return [
      { columnName: 'row_num',            sortingEnabled: false },
      //{ columnName: 'counter',            sortingEnabled: false },
    ]
  }
  getTableFilteringStateColumnExtensions() {
    return [
      { columnName: 'row_num',            filteringEnabled: false },
      { columnName: 'id',                 filteringEnabled: false },
      { columnName: 'created_at',         filteringEnabled: false },
      //{ columnName: 'counter',            filteringEnabled: false },
      { columnName: 'last_download',      filteringEnabled: false },
    ]
  }
}
